import type { SettingsPanelProps } from '../card';
import { ChangeEvent, useId } from 'react';
import { FloatingLabelInputLayout } from 'framework/ui/layout';

export const FormatMessageSettingsPanel = ({
  settings,
  onChange,
  builtInCheckText,
}: SettingsPanelProps<{ formatMessage?: string }>) => {
  const id = useId();
  return (
    <FloatingLabelInputLayout
      source={id}
      label="Error text when the format is wrong"
      placeholder={builtInCheckText}
      helpText="Leave empty to use the default text"
      value={settings.formatMessage ?? ''}
      sx={{ mb: 0 }}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: {
          placeholder: builtInCheckText,
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            const text = event.currentTarget.value;
            onChange({ formatMessage: text.trim() === '' ? undefined : text });
          },
        },
      }}
    />
  );
};
